export default __webpack_public_path__ + "static/media/close.49445575.svg";